import { createTheme } from '@mui/material';

export const theme = createTheme({
  palette: {
    primary: {
      main: 'rgba(255, 87, 34, 0.8)',
      // These are automatically calculated, but you can override if needed
      light: 'rgba(255, 87, 34, 0.6)',
      dark: 'rgba(255, 87, 34, 1)',
      contrastText: '#ffffff'
    }
  }
}); 
